<template>
	<Confirmation :button-options="internalButtonOptions"
		:style="{width: '400px'}"
		@agree="onAgree" @cancel="$emit('cancel')">
		<v-card-text class="pa-4">
			<div class="text-center">
				<p class="text-h3 mb-6">Edit Exact Time Marker</p>
				<v-row>
					<v-col cols="4">
						<v-text-field variant="outlined" density="compact"
							type="number"
							v-model="duration.minutes"
							min="0"
							max="59"
							:rules="[minutesSecondsValidationRule]"
							placeholder="mm"/>
					</v-col>
					<v-col cols="4">
						<v-text-field variant="outlined" density="compact"
							type="number"
							v-model="duration.seconds"
							min="0"
							max="59"
							:rules="[minutesSecondsValidationRule]"
							placeholder="ss"/>
					</v-col>
					<v-col cols="4">
						<v-select v-model="selectedType"
							:items="etmTypes"
							item-title="title"
							item-value="value"
							label="Select ETM Type"
							variant="outlined"
							density="compact"
						/>
					</v-col>
				</v-row>
			</div>
		</v-card-text>
	</Confirmation>
</template>

<script>
/* Modules */
import Confirmation from "@/components/dialogs/Confirmation.vue";

/* Enums */
import EtmTypes from "@/enums/EtmTypes";

export default {
	name: "ETMConfirmation",

	components: {Confirmation},

	props: ["message", "currentType", "hardTime", "buttonOptions"],

	emits: ["agree", "cancel"],

	data() {
		return {
			selectedType: this.currentType,
			duration: {
				minutes: null,
				seconds: null
			}
		}
	},

	computed: {
		etmTypes() {
			return EtmTypes.getArrayValidItems();
		},

		isValid() {
			return this.isValueInRange(this.duration.minutes) &&
			       this.isValueInRange(this.duration.seconds);
		},

		internalButtonOptions() {
			// Derive local button options so we don't mutate the parent's prop.
			// The agree button is disabled when the form is invalid.
			return {
				...this.buttonOptions,
				agreeBtn: {
					...this.buttonOptions?.agreeBtn,
					disabled: !this.isValid
				}
			};
		}
	},

	methods: {
		isValueInRange(value) {
			return value >= 0 && value <= 59;
		},

		minutesSecondsValidationRule(value) {
			return this.isValueInRange(value) || "Value must be between 0 and 59";
		},

		onAgree() {
			// Guard: never emit agree when validation fails
			if (!this.isValid) {
				return;
			}
			this.$emit("agree", this.duration, this.selectedType);
		}
	},

	mounted() {
		if (this.hardTime) {
			this.duration.minutes = this.hardTime ? Math.floor(this.hardTime / 60) : 0;
			this.duration.seconds = this.hardTime ? this.hardTime % 60 : 0;
		}
	}
}
</script>

<style scoped lang="scss">
.confirmation-message {
	white-space: pre-wrap;
	justify-content: center;
	display: flex;
	flex-direction: column;
}
</style>